import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const useAutomationCatalog = (objetoId) => {
  return useQuery(
    ["automationMeta", objetoId || "all"],
    () => fetchData(`/automation-rules/meta${objetoId ? `?objeto=${objetoId}` : ""}`),
    { staleTime: 60_000, refetchOnWindowFocus: false, select: (r) => r }
  );
};

export const useAutomationRules = (page = 1, limit = 10, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["automationRules", page, limit, search],
    () => fetchData(`/automation-rules?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        automationRules: response?.data || [],
        pagination: response?.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (rule) => {
      const method = rule.id ? "PUT" : "POST";
      const endpoint = rule.id ? `/automation-rules/${rule.id}` : `/automation-rules`;
      return fetchData(endpoint, method, rule);
    },
    { onSuccess: () => queryClient.invalidateQueries("automationRules") }
  );

  const activeMutation = useMutation(
    ({ id, ativa }) => fetchData(`/automation-rules/${id}/ativa`, "POST", { ativa }),
    {
      onMutate: async ({ id, ativa }) => {
        await queryClient.cancelQueries("automationRules");
        const previous = queryClient.getQueriesData("automationRules");
        queryClient.setQueriesData("automationRules", (old) => {
          if (!old?.data || !Array.isArray(old.data)) return old;
          return {
            ...old,
            data: old.data.map((rule) =>
              Number(rule.id) === Number(id)
                ? { ...rule, ativa, pausa_motivo: ativa ? null : rule.pausa_motivo }
                : rule
            ),
          };
        });
        return { previous };
      },
      onError: (_error, _vars, context) => {
        context?.previous?.forEach(([key, data]) => queryClient.setQueryData(key, data));
      },
      onSettled: () => queryClient.invalidateQueries("automationRules"),
    }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/automation-rules/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("automationRules") }
  );

  return { ...query, updateMutation, deleteMutation, activeMutation };
};
